module.exports = __webpack_public_path__ + "static/media/mens.256e447e.jpeg";